export const toNumber = (value: string): number | null =>
    value ? Number(value) : null;
